<div class="container">
  <div class="content">
    <h1>Mike Ziegler</h1>
    <p>I apologize for the inconvenience, but the website is currently under construction</p>
    <p>For contact, please send a mail to info@mike-zyeman.com</p>
  </div>
</div>
